import PropTypes from "prop-types"
import React from "react"

import CMSCard from "../cards/CMSCards"
import CMSTypography, {
  StandardTypographyTypes
} from "../typography/CMSTypography"

/**
 * Component to render security incident card in security page
 * @example
 * const item = {
 *   icon: "/static/media/OpenIncidents.78874dce.svg",
 *   primaryText: 0,
 *   secondaryText: "Open Incidents"
 * }
 * return (
 *   <SecurityIncidentCard
 *     item={item}
 *     key={index}
 *     setIsOpen={setIsDrawerOpen}
 *     setType={setDrawerState}
 *     className="mb-2"
 *   />
 * )
 */
function SecurityIncidentCard({ item, setIsOpen, setType }) {
  const onClickHandler = () => {
    setType(item.secondaryText)
    setIsOpen(true)
  }

  return (
    <CMSCard dataTestId={"wrapper-action"} onClick={onClickHandler} clickable>
      <div className="d-flex">
        <img src={item.icon} height={55} alt="icon" className="ml-4" />
        <div className="d-flex flex-column ml-3">
          <div data-testid={"primary-text"}>
            <CMSTypography type={StandardTypographyTypes.subHeading}>
              {item.primaryText}
            </CMSTypography>
          </div>
          <div data-testid={"secondary-text"}>
            <CMSTypography type={StandardTypographyTypes.cardHeading}>
              {item.secondaryText}
            </CMSTypography>
          </div>
        </div>
      </div>
    </CMSCard>
  )
}

SecurityIncidentCard.propTypes = {
  /**
   * Object Containing actual information to be displayed
   */
  item: PropTypes.object,
  /**
   * To open drawer
   */
  setIsOpen: PropTypes.func,
  /**
   * To set opened-drawer type
   */
  setType: PropTypes.func
}

export default SecurityIncidentCard
